import { Component, computed, OnDestroy, OnInit } from '@angular/core';
import { WholesalerInfo } from '../../shared/models/WholesalerInfo'; // Update the path as necessary
import { CommonModule } from '@angular/common';
import { WholesalerInfoService } from '../../shared/services/wholesaler.service';
import { requestWholesalerInfoPlayload } from '../../shared/models/model';
import { Subscription } from 'rxjs';
import { EmulationService } from '../../shared/services/emulation.service';

@Component({
  selector: 'app-contact',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './contact.component.html',
  styleUrl: './contact.component.scss',
})
export class ContactComponent implements OnInit, OnDestroy {
  wholesalersDataObject: any = {};
  wholesalersData: WholesalerInfo[] = [];
  errorMessage: string = '';
  isemulatingUser: boolean = false;
  emulatingUserId: any = '';
  wholeSalerSubscription: Subscription = new Subscription();
  emulatedUser = computed(() => this._emulationService.emulatedUser());
  constructor(
    private _wholeSalerService: WholesalerInfoService,
    private _emulationService: EmulationService,
  ) {}

  ngOnInit(): void {
    this.getWholesalerInfo();
  }

  //Fetching the wholesaler info data
  getWholesalerInfo() {
    // payload for fetching news
    const payLoad: requestWholesalerInfoPlayload = {
      requestingSystem: 'FinPro',
      isEmulating: this.emulatedUser() ? true : false,
      emulatingUserId: this.emulatedUser()?.userId || '',
    };

    this.wholeSalerSubscription = this._wholeSalerService.fetchWholesalerInfo(payLoad).subscribe(
      (data: any) => {
        if (
          data &&
          data.wholesalerList !== null &&
          Array.isArray(data.wholesalerList) &&
          data.wholesalerList.length > 0
        ) {
          this.wholesalersDataObject = data;
          this.wholesalersData = data?.wholesalerList;
        }
      },
      //Error handling
      (error: string) => {
        this.errorMessage = error;
      },
    );
  }
  ngOnDestroy(): void {
    // Unsubscribe from all
    this.wholeSalerSubscription.unsubscribe();
  }
}
